import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router';

import { Api } from '../api';

export const useCheckProgress = () => {
    const [isChecking, setIsChecking] = useState(false);
    const navigate = useNavigate();

    const progress = Api.useProgress();

    const startCheck = () => setIsChecking(true);

    /**
     * Documents extraction might take a while, so check the progress
     * every X seconds to see if it's done.
     */
    const checkExtractProgress = async () => {
        const status = await progress.mutateAsync();

        if (status === true) {
            navigate('/myscore');
        }
    };

    useEffect(() => {
        let interval: any = null;

        if (isChecking) {
            interval = setInterval(() => {
                checkExtractProgress();
            }, 1000);
        }

        return () => clearInterval(interval);
    });

    return { startCheck };
};
